import React from "react";
import Home from "../../../components/Home/Home";

const Short = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default Short;
